import React from 'react'
import styled from 'react-emotion'
import Link from 'gatsby-link'


const BannerContainer = styled.a`
  background-color: #00B386;
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &:hover {
    opacity: 0.7;
    transition: .2s ease-out;
  }
`

const BannerText = styled.p`
  font-style: italic;
  margin-bottom: 0;
  text-align: center;
  color: black;
`

const Banner = (props) => {
  if (!props.text) {
    return null
  }
  if (!props.link) {
    return (
      <Link to={'/schedule'}>
        <BannerContainer href={props.link} target="_blank">
          <BannerText>{props.text}</BannerText>
        </BannerContainer>
      </Link>
    )
  }
  return (
    <BannerContainer href={props.link} target="_blank">
      <BannerText>{props.text}</BannerText>
    </BannerContainer>
  )
}
 
export default Banner;


// WEBPACK FOOTER //
// ./src/components/banner.js